import { Navigate, useLocation } from "react-router-dom";
import { decryptFromStoreLoc } from "./localStorage";

function ProtectLoginRoute({ children, page }) {
  let location = useLocation();
  let isLoggedIn = decryptFromStoreLoc("token");

  if (isLoggedIn) {
    if (page === 'seller') {
      return <Navigate to="/vendor/dashboard" state={{ from: location }} replace />
    } else {
      return <Navigate to="/dashboard" state={{ from: location }} replace />
    }
  }
  return children;
}

export default ProtectLoginRoute;
